module.exports = __webpack_public_path__ + "img/VL_18_03.4c447042.png";